export default {
    xsettings: {
        status: "",
        data: {}
    },
    language: "en",
    rehydrated: false
};



// WEBPACK FOOTER //
// ./src/redux/reducers/config/init.js